module.exports = __webpack_public_path__ + "img/speaker-DachiImedadze-imgs.da0e02f6.png";